/* Victoria Rockera — Lógica de página de producto
   1) Galería con scroll-snap horizontal + dots + flechas
   2) Sincronización de variantes (selects -> hidden id, precio, disponibilidad, SKU)
*/
(function () {
  'use strict';

  function initGallery(root) {
    const track = root.querySelector('[data-vr-gallery-track]');
    if (!track) return;

    const dots = Array.from(root.querySelectorAll('[data-vr-gallery-dot]'));
    const slides = Array.from(track.children);
    const realCount = parseInt(root.getAttribute('data-vr-gallery-count') || '0', 10);
    const n = realCount > 0 ? realCount : slides.length;
    if (slides.length === 0) return;

    // Si las imagenes estan triplicadas (3*n), el bloque del medio empieza en n.
    const isLooped = slides.length === n * 3 && n > 0;
    let teleporting = false;
    let scrollEndTimer = null;

    function centerOf(slide) {
      // Posicion de scroll que centra este slide en el track
      return slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    }

    function findNearestIndex() {
      let nearest = 0;
      let min = Infinity;
      const target = track.scrollLeft + track.clientWidth / 2;
      for (let i = 0; i < slides.length; i++) {
        const c = slides[i].offsetLeft + slides[i].offsetWidth / 2;
        const d = Math.abs(c - target);
        if (d < min) { min = d; nearest = i; }
      }
      return nearest;
    }

    function realIndex(i) {
      return ((i % n) + n) % n;
    }

    function updateDots(realIdx) {
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === realIdx ? 'true' : 'false');
      });
    }

    function scrollTo(idx, smooth) {
      const slide = slides[idx];
      if (!slide) return;
      track.scrollTo({ left: centerOf(slide), behavior: smooth ? 'smooth' : 'auto' });
    }

    // Posicion inicial: si hay bucle, empezamos en el set del medio
    if (isLooped) {
      requestAnimationFrame(() => {
        teleporting = true;
        scrollTo(n, false);
        setTimeout(() => { teleporting = false; }, 60);
      });
    }

    track.addEventListener('scroll', function () {
      if (teleporting) return;
      const idx = findNearestIndex();
      updateDots(realIndex(idx));

      if (!isLooped) return;

      // Cuando el scroll se detiene, revisar si estamos fuera del bloque medio y teleportar
      if (scrollEndTimer) clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(() => {
        const curr = findNearestIndex();
        if (curr < n || curr >= 2 * n) {
          const target = realIndex(curr) + n;
          teleporting = true;
          scrollTo(target, false);
          setTimeout(() => { teleporting = false; }, 60);
        }
      }, 140);
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', function () {
        const i = parseInt(dot.getAttribute('data-vr-gallery-dot'), 10);
        if (isLooped) {
          // Saltar al slide correspondiente del bloque mas cercano
          const curr = findNearestIndex();
          const set = Math.floor(curr / n);
          scrollTo(set * n + i, true);
        } else {
          scrollTo(i, true);
        }
      });
    });

    const prev = root.querySelector('[data-vr-gallery-prev]');
    const next = root.querySelector('[data-vr-gallery-next]');
    function go(dir) {
      const curr = findNearestIndex();
      let target = curr + dir;
      if (!isLooped) {
        target = Math.max(0, Math.min(slides.length - 1, target));
      }
      scrollTo(target, true);
    }
    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
  }

  function formatMoneyEUR(amountCents) {
    const v = (amountCents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }

  function initVariants(section) {
    const dataNode = section.querySelector('[data-vr-product-json]');
    if (!dataNode) return;
    let variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (e) { return; }

    const optionSelects = Array.from(section.querySelectorAll('[data-vr-option]'))
      .sort((a, b) => +a.getAttribute('data-vr-option') - +b.getAttribute('data-vr-option'));
    const hiddenId = section.querySelector('[data-vr-variant-id]');
    const priceEl = section.querySelector('[data-vr-price]');
    const compareEl = section.querySelector('[data-vr-compare]');
    const skuEl = section.querySelector('[data-vr-sku]');
    const addBtn = section.querySelector('[data-vr-add]');
    const initialSku = skuEl ? skuEl.textContent : '';

    function findVariant() {
      const selected = optionSelects.map((s) => s.value || null);
      if (selected.some((v) => !v)) return null;
      return variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3];
        return selected.every((val, i) => opts[i] === val);
      }) || null;
    }

    function update() {
      const v = findVariant();
      if (!v) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Selecciona opciones';
        }
        return;
      }
      if (hiddenId) hiddenId.value = v.id;
      if (priceEl) priceEl.textContent = formatMoneyEUR(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoneyEUR(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      else if (skuEl && initialSku) skuEl.textContent = initialSku;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      }
    }

    optionSelects.forEach((s) => s.addEventListener('change', update));
    update();
  }

  function initQty(section) {
    var input = section.querySelector('.vr-product__qty');
    if (!input) return;
    var decr = section.querySelector('[data-vr-qty-decr]');
    var incr = section.querySelector('[data-vr-qty-incr]');
    var min = parseInt(input.getAttribute('min') || '1', 10);

    function setVal(v) {
      var n = Math.max(min, parseInt(v, 10) || min);
      input.value = n;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (decr) decr.addEventListener('click', function () { setVal(parseInt(input.value, 10) - 1); });
    if (incr) incr.addEventListener('click', function () { setVal(parseInt(input.value, 10) + 1); });

    input.addEventListener('blur', function () {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < min) input.value = min;
    });
  }

  function initZoom() {
    var dialog = document.querySelector('[data-vr-zoom-modal]');
    if (!dialog) return;
    var track = dialog.querySelector('[data-vr-zoom-track]');
    var slides = Array.from(dialog.querySelectorAll('[data-vr-zoom-slide]'));
    var counter = dialog.querySelector('[data-vr-zoom-current]');
    var openBtns = document.querySelectorAll('[data-vr-zoom-open]');
    var closeBtn = dialog.querySelector('[data-vr-zoom-close]');
    var prevBtn = dialog.querySelector('[data-vr-zoom-prev]');
    var nextBtn = dialog.querySelector('[data-vr-zoom-next]');

    function scrollToIndex(idx, smooth) {
      var slide = slides[idx];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    function currentIndex() {
      var nearest = 0;
      var min = Infinity;
      var target = track.scrollLeft + track.clientWidth / 2;
      for (var i = 0; i < slides.length; i++) {
        var c = slides[i].offsetLeft + slides[i].offsetWidth / 2;
        var d = Math.abs(c - target);
        if (d < min) { min = d; nearest = i; }
      }
      return nearest;
    }

    function updateCounter() {
      if (counter) counter.textContent = (currentIndex() + 1).toString();
    }

    function open(idx) {
      if (typeof dialog.showModal === 'function') {
        try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('vr-no-scroll');
      requestAnimationFrame(function () { scrollToIndex(idx, false); updateCounter(); });
    }

    function close() {
      if (typeof dialog.close === 'function') {
        try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
      } else {
        dialog.removeAttribute('open');
      }
      document.documentElement.classList.remove('vr-no-scroll');
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(btn.getAttribute('data-vr-zoom-open'), 10) || 0;
        open(idx);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    dialog.addEventListener('cancel', function () {
      document.documentElement.classList.remove('vr-no-scroll');
    });

    if (track) {
      track.addEventListener('scroll', function () {
        if (track._raf) cancelAnimationFrame(track._raf);
        track._raf = requestAnimationFrame(updateCounter);
      }, { passive: true });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      var idx = (currentIndex() - 1 + slides.length) % slides.length;
      scrollToIndex(idx, true);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var idx = (currentIndex() + 1) % slides.length;
      scrollToIndex(idx, true);
    });

    document.addEventListener('keydown', function (e) {
      if (!dialog.open) return;
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-vr-gallery]').forEach(initGallery);
    document.querySelectorAll('.vr-product').forEach(initVariants);
    document.querySelectorAll('.vr-product').forEach(initQty);
    initZoom();
  });
})();
